export const ERROR_MESSAGES = {
  PROCESSING_ERROR: "Sorry, some error processing your request.",
};

export const PLACEHOLDERS = {
  CHAT_INPUT: "Enter a prompt",
};
